import { render } from "./PrescriberTwoFactorDisableAuth.vue?vue&type=template&id=09d5fcec"
import script from "./PrescriberTwoFactorDisableAuth.vue?vue&type=script&lang=js"
export * from "./PrescriberTwoFactorDisableAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__